import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router';

export interface PageTitle {
    setPageTitle(title: string);
    pageTitle?: string;
}

/**
 * Mini contexte pour gérer plus facilement les titres de pages asynchrones pouvant
 * provenir d'un composant nesté dans l'arbre (en l'occurence, lors de la visualisation d'un article,
 * il nous fallait le titre du dit article).
 */
const PageTitleContext = createContext<PageTitle>({
    setPageTitle: () => {},
});

interface Props {
    children: React.ReactNode;
}

export function PageTitleProvider({ children }: Props) {
    const [pageTitle, setPageTitle] = useState<string>();
    const location = useLocation();

    useEffect(() => {
        // On réinitialise le titre sur changement de route.
        setPageTitle(undefined);
    }, [location, setPageTitle]);

    return (
        <PageTitleContext.Provider
            value={{
                pageTitle,
                setPageTitle,
            }}
        >
            {children}
        </PageTitleContext.Provider>
    );
}

export const usePageTitleContext = () => useContext(PageTitleContext);
